import React from 'react';

/** Veritage wordmark with the purple radial mark, as used in the veritage.io header. */
export default function VeritageLogo({ className = '', height = 28, mono = false, style = {} }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/veritage-logo-color.svg`}
      alt="Veritage"
      className={className}
      height={height}
      width={433}
      style={{
        height,
        width: 'auto',
        display: 'block',
        ...(mono ? { filter: 'brightness(0) invert(1)' } : {}),
        ...style,
      }}
    />
  );
}
